import {createRouter, createWebHistory} from 'vue-router';
import AppLayout from '../views/layouts/AppLayout.vue';
import AdminLayout from '../views/layouts/AdminLayout.vue';
import AccountLayout from '../views/layouts/AccountLayout.vue';
import Index from '../views/pages/Index.vue';
import { useUser } from '@/composables/useUser';

import adminRoutes from '@/router/admin-route';
import clientRoutes from '@/router/client-route';
import specialistRoutes from '@/router/specialist-route';

const routes = [
    {
        path: '/',
        component: AppLayout,
        children: [
            {
                path: '',
                name: 'Index',
                component: Index,
                // meta: {
                //     title: 'RezerwujWizyty.pl'
                // }
            },
            {
                path: ':category/:subCategory?',
                name: 'Category',
                component: () => import('@/views/pages/Category.vue')
            },
            {
                path: 'specjalisci',
                name: 'Specialists',
                component: () => import('@/views/pages/Specialists/Index.vue'),
                // meta: {
                //     title: 'Specjaliści'
                // }
            },
            {
                path: 'specjalisci/:id',
                name: 'Specialist',
                component: () => import('@/views/pages/Specialists/Show.vue')
            },
            {
                path: 'login',
                name: 'Login',
                component: () => import('../views/pages/auth/Login.vue'),
                // meta: {
                //     title: 'Zaloguj się'
                // }
            },
            {
                path: 'register',
                name: 'Register',
                component: () => import('../views/pages/auth/Register.vue'),
                // meta: {
                //     title: 'Zarejestruj się'
                // }
            },
            {
                path: 'forgot-password',
                name: 'ForgotPassword',
                component: () => import('../views/pages/auth/ForgotPassword.vue'),
                // meta: {
                //     title: 'Przypomnij hasło'
                // }
            },
            {
                path: 'v',
                component: () => import('@/views/pages/auth/VerifyStatus.vue')
            },
            {
                path: 'test',
                component: () => import('@/views/pages/Test.vue')
            },
            {
                path: 'regulamin',
                name: 'Terms',
                component: () => import('@/views/pages/static/Terms.vue'),
                // meta: {
                //     title: 'Regulamin'
                // }
            },
            {
                path: 'polityka-prywatnosci',
                name: 'PrivacyPolicy',
                component: () => import('@/views/pages/static/PrivacyPolicy.vue'),
                // meta: {
                //     title: 'Polityka prywatności'
                // }
            },
            {
                path: 'kontakt',
                name: 'Contact',
                component: () => import('@/views/pages/static/Contact.vue'),
                // meta: {
                //     title: 'Kontakt'
                // }
            },
            {
                path: 'o-nas',
                name: 'AboutUs',
                component: () => import('@/views/pages/static/AboutUs.vue'),
                // meta: {
                //     title: 'O nas'
                // }
            }
        ]
    },
    {
        path: '/administration',
        component: AdminLayout,
        children: adminRoutes,
        meta: {
            requiresAuth: true,
            requiresRole: 'admin'
        }
    },
    {
        path: '/account',
        name: 'account',
        component: AccountLayout,
        children: [],
        meta: {
            requiresAuth: true
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0}
        }
    }
})

const { fetchUserData } = useUser();

router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('token');
    if (to.matched.some(record => record.meta.requiresRole === 'admin')) {
        if (!token) {
            next({ name: 'Login' });
            return;
        }
        const user = await fetchUserData();
        if (!user || user.role !== 'admin') {
            next({ name: 'Index' });
            return;
        }   
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('type', user.type);
    }
    if (to.path.startsWith('/account')) {
        if (!token) {
            next({ name: 'Login' });
            return;
        }
        const user = await fetchUserData();
        if (!user) {
            next({ name: 'Login' });
            return;
        }
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('type', user.type);
        const accountRoute = router.getRoutes().find(r => r.name === 'account');
        if (!accountRoute) {
            next({ name: 'Index' });
            return;
        }
        const hasClientRoutes = accountRoute.children.some(r => r.name === 'ClientReservations' || r.name === 'ClientSettings');
        const hasSpecialistRoutes = accountRoute.children.some(r => r.name === 'AccountLocalization' || r.name === 'AccountContact');
        if (user.type === 'client') {
            if (!hasClientRoutes || hasSpecialistRoutes) {
                router.removeRoute('account');
                router.addRoute({
                    path: '/account',
                    name: 'account',
                    component: AccountLayout,
                    children: clientRoutes,
                    meta: { requiresAuth: true }
                });
                return next(to.fullPath);
            }
        } else if (user.type === 'specialist') {
            if (!hasSpecialistRoutes || hasClientRoutes) {
                router.removeRoute('account');
                router.addRoute({
                    path: '/account',
                    name: 'account',
                    component: AccountLayout,
                    children: specialistRoutes,
                    meta: { requiresAuth: true }
                });
                return next(to.fullPath);
            }
        } else {
            next({ name: 'Login' });
            return;
        }
    }
    next();
})

const defaultTitle = 'RezerwujWizyty.pl'


router.afterEach((to) => {
    const nearestWithTitle = [...to.matched].reverse().find(route => route.meta && route.meta.title)

    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title
    } else {
        document.title = defaultTitle
    }
})

export default router
